export enum EntityType {
    Recipes = 1,
    Products = 2,
    Stages = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/EntityType.ts